import React, { Component } from "react";
import { Spin, Select } from "antd";
import axios from "axios";
import debounce from "lodash.debounce";

const { Option } = Select;

const esObjectId = (v) => /^[a-f\d]{24}$/i.test(String(v || ""));

// Select que SOLO lista clientes que son alumnos (tienen escuela). Busca por
// nombre o matrícula. Soporta `escuelaId` (limitar a una escuela) y
// `excluirClienteId` (no listar al propio alumno).
class SelectAlumnosItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      opciones: [],
      cargando: false,
      primerCarga: true,
      texto: "",
    };
    this.buscarAlumnos = debounce(this.buscarAlumnos.bind(this), 300);
  }

  componentDidMount() {
    this.buscarAlumnos("", true);
    if (this.props.value) this.asegurarValor(this.props.value);
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.escuelaId !== this.props.escuelaId ||
      prevProps.excluirClienteId !== this.props.excluirClienteId
    ) {
      this.setState({ opciones: [], primerCarga: true, texto: "" }, () => {
        this.buscarAlumnos("", true);
        if (this.props.value) this.asegurarValor(this.props.value);
      });
      return;
    }
    if (prevProps.value !== this.props.value && this.props.value) {
      this.asegurarValor(this.props.value);
    }
  }


  async asegurarValor(value) {
    const val = value?.toString();
    if (!val || !esObjectId(val)) return;
    if (this.state.opciones.some((o) => o._id?.toString() === val)) return;
    try {
      const res = await axios.post(
        "clientes/selectAlumnosItem",
        {
          query: val,
          skip: 0,
          empresaId: this.props.empresaId,
          escuelaId: this.props.escuelaId,
          excluirClienteId: this.props.excluirClienteId,
        },
        { headers: this.props.headersToken }
      );
      if (res.data.success === 2 && res.data.alumnos?.length) {
        this.setState((prev) => {
          const existentes = new Set(
            prev.opciones.map((o) => o._id?.toString())
          );
          const nuevos = res.data.alumnos.filter(
            (a) => !existentes.has(a._id?.toString())
          );
          return { opciones: [...nuevos, ...prev.opciones] };
        });
      }
    } catch (err) {
      console.error(err);
    }
  }

  async buscarAlumnos(texto, inicial, append = false) {
    this.setState({ cargando: true });
    try {
      const res = await axios.post(
        "clientes/selectAlumnosItem",
        {
          query: append ? this.state.texto || "" : texto || "",
          skip: append ? this.state.opciones.length : 0,
          empresaId: this.props.empresaId,
          escuelaId: this.props.escuelaId,
          excluirClienteId: this.props.excluirClienteId,
        },
        { headers: this.props.headersToken }
      );

      if (res.data.success === 2) {
        this.setState(
          (prev) => ({
            opciones: append
              ? [...prev.opciones, ...res.data.alumnos]
              : res.data.alumnos,
            primerCarga: false,
            texto: append ? prev.texto : texto,
          }),
          () => {
            if (!append && this.props.value)
              this.asegurarValor(this.props.value);
          }
        );
      } else {
        this.setState({ opciones: [] });
      }
    } catch (err) {
      console.error(err);
      this.setState({ opciones: [] });
    } finally {
      this.setState({ cargando: false });
    }
  }

  render() {
    const { noBuscar, disabled, sinBorde, width, style, placeholder, ...rest } =
      this.props;

    const opcionesUnicas = [];
    const vistos = new Set();
    for (const a of this.state.opciones) {
      const id = a._id?.toString();
      if (vistos.has(id)) continue;
      vistos.add(id);
      opcionesUnicas.push(a);
    }

    return (
      <Select
        className={`custom-disabled-select ${disabled ? "custom-disabled" : ""}`}
        dropdownMatchSelectWidth={false}
        disabled={disabled}
        showSearch={!noBuscar}
        filterOption={false}
        onSearch={this.buscarAlumnos}
        loading={this.state.cargando}
        notFoundContent={
          this.state.cargando ? "Buscando..." : "No se encontraron alumnos"
        }
        dropdownRender={(menu) => (
          <Spin spinning={this.state.cargando}>{menu}</Spin>
        )}
        {...rest}
        onChange={(value) => {
          const alumno = this.state.opciones.find((e) => e._id === value);
          if (this.props.onChange) this.props.onChange(value, alumno);
        }}
        placeholder={placeholder}
        style={{ width: width || "100%", ...style }}
        bordered={!sinBorde}
        onPopupScroll={(e) => {
          const { target } = e;
          if (target.scrollTop + target.offsetHeight === target.scrollHeight) {
            this.buscarAlumnos(this.state.texto || "", false, true);
          }
        }}
      >
        {opcionesUnicas.map((a) => (
          <Option key={a._id} value={a._id}>
            {a.stringBuscar || a.nombre}
          </Option>
        ))}
      </Select>
    );
  }
}

export default SelectAlumnosItem;
